import { Grid } from '@material-ui/core';
import { EntityLayout, EntityLinksCard } from '@backstage/plugin-catalog';
import {
  EntityMembersListCard,
  EntityOwnershipCard,
} from '@backstage/plugin-org';
import { GroupSoundcheckContent } from '@spotify/backstage-plugin-soundcheck';
import { CustomGroupProfileCard } from '@internal/backstage-plugin-onboard-squads';
import { entityWarningContent } from './EntityWarningContent';
import {
  isKratixEntity,
  SquadManager,
} from '@internal/backstage-plugin-kratix-manager';

export const groupPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3}>
        {entityWarningContent}
        <Grid item xs={12} md={6}>
          <CustomGroupProfileCard />
        </Grid>
        <Grid item xs={12} md={6}>
          <EntityOwnershipCard variant="gridItem" />
        </Grid>
        <Grid item xs={12} md={6}>
          <EntityMembersListCard />
        </Grid>
        <Grid item xs={12} md={6}>
          <EntityLinksCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>
    <EntityLayout.Route path="/soundcheck" title="Soundcheck">
      <GroupSoundcheckContent />
    </EntityLayout.Route>
    <EntityLayout.Route path="/manage" title="Manage" if={isKratixEntity()}>
      <SquadManager />
    </EntityLayout.Route>
  </EntityLayout>
);
